import { render, staticRenderFns } from "./StampEmptyImage.vue?vue&type=template&id=165724d6&scoped=true&"
import script from "./StampEmptyImage.vue?vue&type=script&lang=js&"
export * from "./StampEmptyImage.vue?vue&type=script&lang=js&"
import style0 from "./StampEmptyImage.vue?vue&type=style&index=0&id=165724d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165724d6",
  null
  
)

export default component.exports